import { Box, Grid, Typography } from '@material-ui/core'
import { ArrowDropDown, HelpOutline, Mood, SentimentDissatisfied } from '@material-ui/icons'

export const OrdersWelcomeTable = (): JSX.Element => {
  return (
    <>
      <Grid container style={{ textAlign: 'center' }}>
        <Grid container item xs={12}>
          <Grid item xs={4}>
            <SentimentDissatisfied fontSize="large" color="primary" />
            <Box marginBottom={2}>
              <Typography variant="h6" color="primary">
                Standard
              </Typography>
            </Box>
            <Box className="pill">New order (unpaid)</Box>
            <ArrowDropDown color="primary" className="pill-downArrow" />
            <Box className="pill">New order (paid)</Box>
            <ArrowDropDown color="primary" className="pill-downArrow" />
          </Grid>
          <Grid item xs={4}>
            <Mood fontSize="large" color="primary" />
            <Box marginBottom={2}>
              <Typography variant="h6" color="primary">
                PowerTools
              </Typography>
            </Box>
            <Box className="pill">New order (unpaid)</Box>
            <ArrowDropDown color="primary" className="pill-downArrow" />
            <Box className="pill">New order (paid)</Box>
            <ArrowDropDown color="primary" className="pill-downArrow" />
          </Grid>
          <Grid item xs={4}></Grid>
        </Grid>
        <Grid container item xs={12}>
          <Grid item xs={4} style={{ alignSelf: 'center' }}>
            <Box>
              <HelpOutline fontSize="large" color="primary" />
              <Typography variant="subtitle2">
                You have no way to manage what happens to your order while being prepared
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={4} style={{ alignSelf: 'center' }}>
            <Box className="special-pill">Picking</Box>
            <ArrowDropDown color="primary" className="pill-downArrow" />
            <Box className="special-pill">Packing</Box>
            <ArrowDropDown color="primary" className="pill-downArrow" />
            <Box className="special-pill">Shipping</Box>
          </Grid>
          <Grid item xs={4} style={{ alignSelf: 'center', textAlign: 'left' }}>
            <Typography variant="subtitle2" color="primary">
              We added more steps based on the most widespread order handling methods
            </Typography>
          </Grid>
        </Grid>
        <Grid container item xs={12}>
          <Grid item xs={4}>
            <ArrowDropDown color="primary" className="pill-downArrow" />
            <Box className="pill">Shipped order</Box>
            <ArrowDropDown color="primary" className="pill-downArrow" />
            <Box className="pill">Concluded (arrived)</Box>
          </Grid>
          <Grid item xs={4}>
            <ArrowDropDown color="primary" className="pill-downArrow" />
            <Box className="pill">Shipped order</Box>
            <ArrowDropDown color="primary" className="pill-downArrow" />
            <Box className="pill">Concluded (arrived)</Box>
          </Grid>
          <Grid item xs={4}></Grid>
        </Grid>
      </Grid>
    </>
  )
}
